

const asset = require('./asset');
const blockTransformer = require('./block');
const dealerTransformer = require('./dealer');
const variantTransformer = require('./variant');
const leaseTransformer = require('./lease');
const leadSchemaTransformer = require('./leadSchema');
const makeTransformer = require('./make');
const modelTransformer = require('./model');
const colorTransformer = require('./color');
const equipmentTransformer = require('./equipment');
const equipmentFactoryTransformer = require('./equipmentFactory');
const isResolvedCollection = require('../contentful/is-resolved-collection');
const isResolvedResource = require('../contentful/is-resolved-resource');

const createAssetLink = (asset) => {
  return {
    sys: {
      type: 'Link',
      linkType: 'Asset',
      id: asset.id
    }
  };
};

const createEntryLink = (entry) => {
  return {
    sys: {
      type: 'Link',
      linkType: 'Entry',
      id: entry.id
    }
  };
};

module.exports = {
  contentfulToInternal(entry) {
    const result = {
      id: entry.sys.id,
      published: Boolean(entry.sys.publishedVersion),
      updated: entry.sys.publishedVersion && entry.sys.version > entry.sys.publishedVersion + 1,
      draft: !entry.sys.publishedVersion,
      archived: Boolean(entry.sys.archivedVersion),
      name: (entry.fields.name ? entry.fields.name['nb-NO'] : ''),
      summary: (entry.fields.summary ? entry.fields.summary['nb-NO'] : ''),
      url: (entry.fields.url ? entry.fields.url['nb-NO'] : ''),
      type: (entry.fields.type ? entry.fields.type['nb-NO'] : ''),
      intro: (entry.fields.intro ? entry.fields.intro['nb-NO'] : ''),
      description: (entry.fields.description ? entry.fields.description['nb-NO'] : ''),
      titleBackground: (entry.fields.titleBackground ? entry.fields.titleBackground['nb-NO'] : ''),
      bodytext: [],
      price: (entry.fields.price ? entry.fields.price['nb-NO'] : null),
      loanRate: (entry.fields.loanRate ? entry.fields.loanRate['nb-NO'] : null),
      loanRate2: (entry.fields.loanRate2 ? entry.fields.loanRate2['nb-NO'] : null),
      loanRateTotalTerms: (entry.fields.loanRateTotalTerms ? entry.fields.loanRateTotalTerms['nb-NO'] : null),
      loanFixedRateTerms: (entry.fields.loanFixedRateTerms ? entry.fields.loanFixedRateTerms['nb-NO'] : null),
      minimumEquityPercentage: (entry.fields.minimumEquityPercentage ? entry.fields.minimumEquityPercentage['nb-NO'] : null),
      colorDescription: (entry.fields.colorDescription ? entry.fields.colorDescription['nb-NO'] : ''),

      listImage: null,
      mainImage: null,

      priority: 0,
      startDate: null,
      expiryDate: null,

      // This replaces all commented fields below with a JSON field.
      // (Except for reference fields)
      callToActions: {},
      // callToActionHeader: null,
      // callToActionText: null,
      // callToActionButtonText: null,
      // callToActionForm: null,
      callToActionFormExt: null,
      // callToActionUrlExternal: null,

      // showSecondaryCtaButton: (entry.fields.showSecondaryCtaButton ? entry.fields.showSecondaryCtaButton['nb-NO'] : false),
      // callToActionButtonText2: (entry.fields.callToActionButtonText2 ? entry.fields.callToActionButtonText2['nb-NO'] : null),
      // callToActionButtonStyle2: (entry.fields.callToActionButtonStyle2 ? entry.fields.callToActionButtonStyle2['nb-NO'] : null),
      // callToActionForm2: (entry.fields.callToActionForm2 ? entry.fields.callToActionForm2['nb-NO'] : null),
      callToActionFormExt2: null,
      // callToActionTitle2: (entry.fields.callToActionTitle2 ? entry.fields.callToActionTitle2['nb-NO'] : null),
      // callToActionDescription2: (entry.fields.callToActionDescription2 ? entry.fields.callToActionDescription2['nb-NO'] : null),
      // callToActionUrlExternal2: (entry.fields.callToActionUrlExternal2 ? entry.fields.callToActionUrlExternal2['nb-NO'] : null),

      // showTertiaryCtaButton: (entry.fields.showTertiaryCtaButton ? entry.fields.showTertiaryCtaButton['nb-NO'] : null),
      // callToActionButtonText3: (entry.fields.callToActionButtonText3 ? entry.fields.callToActionButtonText3['nb-NO'] : null),
      // callToActionButtonStyle3: (entry.fields.callToActionButtonStyle3 ? entry.fields.callToActionButtonStyle3['nb-NO'] : null),
      // callToActionForm3: (entry.fields.callToActionForm3 ? entry.fields.callToActionForm3['nb-NO'] : null),
      callToActionFormExt3: null,
      // callToActionTitle3: (entry.fields.callToActionTitle3 ? entry.fields.callToActionTitle3['nb-NO'] : null),
      // callToActionDescription3: (entry.fields.callToActionDescription3 ? entry.fields.callToActionDescription3['nb-NO'] : null),
      // callToActionUrlExternal3: (entry.fields.callToActionUrlExternal3 ? entry.fields.callToActionUrlExternal3['nb-NO'] : null),

      dealers: [],
      dealerIds: [],
      model: null,
      // variants: [], // Not initialized to prevent false matches on save (in entry-update.js)
      lease: null,
      hideCarPreview: false,
      showCampaignOnModelPage: false,
      showCampaignInConfigurator: false,
      loanExclusive: false,
      hiddenCampaign: false,
      hideDates: false,
      externalCampaignPage: false,
      mfRotationOverride: false,
      makes: [],
      variables: (entry.fields.variables ? entry.fields.variables['nb-NO'] : {})

      // Included stuff (note, these fields are stored in a single field in contentful, see transformer)
      // (Not initialized to prevent false matches on save (in entry-update.js))
      // includedEquipments: [],
      // includedFactoryEquipments: [],
      // availableColors: []
    };

    if (entry.sys && entry.sys.contentType) {
      result.contentType = entry.sys.contentType.sys.id;
    }

    // Content blocks for the campaign
    if (entry.fields.bodytext && entry.fields.bodytext['nb-NO'] && isResolvedCollection(entry.fields.bodytext['nb-NO'])) {
      result.bodytext = entry.fields.bodytext['nb-NO'].map(blockTransformer.contentfulToInternal);
    }

    // Assets:
    if (entry.fields.listImage && entry.fields.listImage['nb-NO'] && isResolvedResource(entry.fields.listImage['nb-NO'])) {
      result.listImage = asset.contentfulToInternal(entry.fields.listImage['nb-NO']);
    }

    if (entry.fields.mainImage && entry.fields.mainImage['nb-NO'] && isResolvedResource(entry.fields.mainImage['nb-NO'])) {
      result.mainImage = asset.contentfulToInternal(entry.fields.mainImage['nb-NO']);
    }

    // Publishing:
    if (entry.fields.priority && entry.fields.priority['nb-NO']) {
      result.priority = parseInt(entry.fields.priority['nb-NO'], 10);
    }

    if (entry.fields.startDate && entry.fields.startDate['nb-NO']) {
      result.startDate = new Date(entry.fields.startDate['nb-NO']);
    }

    if (entry.fields.expiryDate && entry.fields.expiryDate['nb-NO']) {
      result.expiryDate = new Date(entry.fields.expiryDate['nb-NO']);
    }

    if (entry.fields.callToActions && entry.fields.callToActions['nb-NO']) {
      result.callToActionHeader = entry.fields.callToActions['nb-NO'].callToActionHeader;
      result.callToActionText = entry.fields.callToActions['nb-NO'].callToActionText;
      // Add a fallback for this new field, so that edits of existing campaigns will get this set. This default value is also set on create empty/new
      result.callToActionInfo = entry.fields.callToActions['nb-NO'].callToActionInfo ?? 'Registrer din interesse og vi kontakter deg så raskt som mulig';
      result.callToActionButtonText = entry.fields.callToActions['nb-NO'].callToActionButtonText;
      result.callToActionForm = entry.fields.callToActions['nb-NO'].callToActionForm;
      result.callToActionUrlExternal = entry.fields.callToActions['nb-NO'].callToActionUrlExternal;

      result.showSecondaryCtaButton = entry.fields.callToActions['nb-NO'].showSecondaryCtaButton;
      result.callToActionButtonText2 = entry.fields.callToActions['nb-NO'].callToActionButtonText2;
      result.callToActionButtonStyle2 = entry.fields.callToActions['nb-NO'].callToActionButtonStyle2;
      result.callToActionForm2 = entry.fields.callToActions['nb-NO'].callToActionForm2;
      result.callToActionTitle2 = entry.fields.callToActions['nb-NO'].callToActionTitle2;
      result.callToActionDescription2 = entry.fields.callToActions['nb-NO'].callToActionDescription2;
      result.callToActionUrlExternal2 = entry.fields.callToActions['nb-NO'].callToActionUrlExternal2;

      result.showTertiaryCtaButton = entry.fields.callToActions['nb-NO'].showTertiaryCtaButton;
      result.callToActionButtonText3 = entry.fields.callToActions['nb-NO'].callToActionButtonText3;
      result.callToActionButtonStyle3 = entry.fields.callToActions['nb-NO'].callToActionButtonStyle3;
      result.callToActionForm3 = entry.fields.callToActions['nb-NO'].callToActionForm3;
      result.callToActionTitle3 = entry.fields.callToActions['nb-NO'].callToActionTitle3;
      result.callToActionDescription3 = entry.fields.callToActions['nb-NO'].callToActionDescription3;
      result.callToActionUrlExternal3 = entry.fields.callToActions['nb-NO'].callToActionUrlExternal3;
    }

    if (entry.fields.callToActionFormExt && entry.fields.callToActionFormExt['nb-NO'] && isResolvedResource(entry.fields.callToActionFormExt['nb-NO'])) {
      result.callToActionFormExt = leadSchemaTransformer.contentfulToInternal(entry.fields.callToActionFormExt['nb-NO']);
    }

    if (entry.fields.callToActionFormExt2 && entry.fields.callToActionFormExt2['nb-NO'] && isResolvedResource(entry.fields.callToActionFormExt2['nb-NO'])) {
      result.callToActionFormExt2 = leadSchemaTransformer.contentfulToInternal(entry.fields.callToActionFormExt2['nb-NO']);
    }

    if (entry.fields.callToActionFormExt3 && entry.fields.callToActionFormExt3['nb-NO'] && isResolvedResource(entry.fields.callToActionFormExt3['nb-NO'])) {
      result.callToActionFormExt3 = leadSchemaTransformer.contentfulToInternal(entry.fields.callToActionFormExt3['nb-NO']);
    }

    if (entry.fields.dealers && entry.fields.dealers['nb-NO']) {
      result.dealerIds = entry.fields.dealers['nb-NO'].map((dealer) => dealer.sys.id);
    }

    // Dealer links:
    if (entry.fields.dealers && entry.fields.dealers['nb-NO'] && isResolvedCollection(entry.fields.dealers['nb-NO'])) {
      result.dealers = entry.fields.dealers['nb-NO'].map(dealerTransformer.contentfulToInternal);
    }

    if (entry.fields.variants && entry.fields.variants['nb-NO'] && isResolvedCollection(entry.fields.variants['nb-NO'])) {
      result.variants = entry.fields.variants['nb-NO'].map(variantTransformer.contentfulToInternal);
    }

    // Model link:
    if (entry.fields.model && entry.fields.model['nb-NO'] && isResolvedResource(entry.fields.model['nb-NO'])) {
      result.model = modelTransformer.contentfulToInternal(entry.fields.model['nb-NO']);
    }

    if (entry.fields.lease && entry.fields.lease['nb-NO'] && isResolvedResource(entry.fields.lease['nb-NO'])) {
      result.lease = leaseTransformer.contentfulToInternal(entry.fields.lease['nb-NO']);
    }

    if (entry.fields.hideCarPreview) {
      result.hideCarPreview = entry.fields.hideCarPreview['nb-NO'];
    }

    if (entry.fields.showCampaignOnModelPage) {
      result.showCampaignOnModelPage = entry.fields.showCampaignOnModelPage['nb-NO'];
    }

    if (entry.fields.showCampaignInConfigurator) {
      result.showCampaignInConfigurator = entry.fields.showCampaignInConfigurator['nb-NO'];
    }

    if (entry.fields.loanExclusive) {
      result.loanExclusive = entry.fields.loanExclusive['nb-NO'];
    }

    if (entry.fields.hideDates) {
      result.hideDates = entry.fields.hideDates['nb-NO'];
    }

    if (entry.fields.hiddenCampaign) {
      result.hiddenCampaign = entry.fields.hiddenCampaign['nb-NO'];
    }

    if (entry.fields.externalCampaignPage) {
      result.externalCampaignPage = entry.fields.externalCampaignPage['nb-NO'];
    }

    if (entry.fields.mfRotationOverride) {
      result.mfRotationOverride = entry.fields.mfRotationOverride['nb-NO'];
    }

    // Make links:
    if (entry.fields.makes && entry.fields.makes['nb-NO'] && isResolvedCollection(entry.fields.makes['nb-NO'])) {
      result.makes = entry.fields.makes['nb-NO'].map(makeTransformer.contentfulToInternal);
    }

    if (entry.fields.includedEquipment && entry.fields.includedEquipment['nb-NO'] && isResolvedCollection(entry.fields.includedEquipment['nb-NO'])) {
      result.includedEquipments = entry.fields.includedEquipment['nb-NO'].filter(
        (resource) => resource.sys.contentType.sys.id === 'equipment'
      ).map(equipmentTransformer.contentfulToInternal);

      result.includedFactoryEquipments = entry.fields.includedEquipment['nb-NO'].filter(
        (resource) => resource.sys.contentType.sys.id === 'equipmentFactory'
      ).map(equipmentFactoryTransformer.contentfulToInternal);

      result.availableColors = entry.fields.includedEquipment['nb-NO'].filter(
        (resource) => resource.sys.contentType.sys.id === 'color'
      ).map(colorTransformer.contentfulToInternal);
    }

    // Update model status based on content blocks status
    result.bodytext.forEach((rd) => {
      if (!rd.published || rd.updated) {
        result.updated = true;
      }
    });

    return result;
  },

  internalToContentful(campaign) {
    const result = {
      fields: {},
      overwriteKeys: []
    };

    if (typeof campaign.name !== 'undefined') {
      result.fields.name = {
        'nb-NO': campaign.name
      };
    }

    if (typeof campaign.url !== 'undefined') {
      result.fields.url = {
        'nb-NO': campaign.url
      };
    }

    if (typeof campaign.summary !== 'undefined') {
      result.fields.summary = {
        'nb-NO': campaign.summary
      };
    }

    if (typeof campaign.type !== 'undefined') {
      result.fields.type = {
        'nb-NO': campaign.type
      };
    }

    if (typeof campaign.intro !== 'undefined') {
      result.fields.intro = {
        'nb-NO': campaign.intro
      };
    }

    if (typeof campaign.description !== 'undefined') {
      result.fields.description = {
        'nb-NO': campaign.description
      };
    }

    if (typeof campaign.titleBackground !== 'undefined') {
      result.fields.titleBackground = {
        'nb-NO': campaign.titleBackground
      };
    }

    if (typeof campaign.price !== 'undefined') {
      result.fields.price = {
        'nb-NO': parseInt(campaign.price, 10)
      };
    }

    if (typeof campaign.loanRate !== 'undefined') {
      result.fields.loanRate = {
        'nb-NO': (typeof campaign.loanRate === 'string') ? parseFloat(campaign.loanRate.replace(',', '.')) : campaign.loanRate
      };
    }

    if (typeof campaign.loanRate2 !== 'undefined') {
      result.fields.loanRate2 = {
        'nb-NO': (typeof campaign.loanRate2 === 'string') ? parseFloat(campaign.loanRate2.replace(',', '.')) : campaign.loanRate2
      };
    }

    if (typeof campaign.loanRateTotalTerms !== 'undefined') {
      result.fields.loanRateTotalTerms = {
        'nb-NO': parseInt(campaign.loanRateTotalTerms, 10)
      };
    }

    if (typeof campaign.loanFixedRateTerms !== 'undefined') {
      result.fields.loanFixedRateTerms = {
        'nb-NO': parseInt(campaign.loanFixedRateTerms, 10)
      };
    }

    if (typeof campaign.minimumEquityPercentage !== 'undefined') {
      result.fields.minimumEquityPercentage = {
        'nb-NO': parseInt(campaign.minimumEquityPercentage, 10)
      };
    }

    if (typeof campaign.colorDescription !== 'undefined') {
      result.fields.colorDescription = {
        'nb-NO': campaign.colorDescription
      };
    }

    // Content blocks for the campaign
    if (typeof campaign.bodytext !== 'undefined') {
      result.fields.bodytext = {
        'nb-NO': campaign.bodytext ? campaign.bodytext.map(createEntryLink) : null
      };
    }

    // Assets
    if (typeof campaign.listImage !== 'undefined') {
      result.fields.listImage = {
        'nb-NO': campaign.listImage ? createAssetLink(campaign.listImage) : null
      };
    }

    if (typeof campaign.mainImage !== 'undefined') {
      result.fields.mainImage = {
        'nb-NO': campaign.mainImage ? createAssetLink(campaign.mainImage) : null
      };
    }

    // Publishing:
    if (typeof campaign.priority !== 'undefined') {
      result.fields.priority = {
        'nb-NO': parseInt(campaign.priority, 10)
      };
    }

    if (typeof campaign.startDate !== 'undefined') {
      result.fields.startDate = {
        'nb-NO': campaign.startDate ? campaign.startDate.toISOString() : null
      };
    }

    if (typeof campaign.expiryDate !== 'undefined') {
      result.fields.expiryDate = {
        'nb-NO': campaign.expiryDate ? campaign.expiryDate.toISOString() : null
      };
    }

    // Call to action:
    if (
      campaign.callToActionHeader ||
      campaign.callToActionText ||
      campaign.callToActionButtonText ||
      campaign.callToActionForm ||
      campaign.callToActionUrlExternal ||
      campaign.showSecondaryCtaButton ||
      campaign.showTertiaryCtaButton
    ) {
      result.fields.callToActions = {
        'nb-NO': {
          callToActionHeader: campaign.callToActionHeader || undefined,
          callToActionText: campaign.callToActionText || undefined,
          callToActionInfo: campaign.callToActionInfo, // allow empty string here, as we have fallback of undefined to a default text in sites
          callToActionButtonText: campaign.callToActionButtonText || undefined,
          callToActionForm: campaign.callToActionForm || undefined,
          callToActionUrlExternal: campaign.callToActionUrlExternal || undefined,
          showSecondaryCtaButton: campaign.showSecondaryCtaButton || undefined,
          callToActionButtonText2: campaign.callToActionButtonText2 || undefined,
          callToActionButtonStyle2: campaign.callToActionButtonStyle2 || undefined,
          callToActionForm2: campaign.callToActionForm2 || undefined,
          callToActionTitle2: campaign.callToActionTitle2 || undefined,
          callToActionDescription2: campaign.callToActionDescription2 || undefined,
          callToActionUrlExternal2: campaign.callToActionUrlExternal2 || undefined,
          showTertiaryCtaButton: campaign.showTertiaryCtaButton || undefined,
          callToActionButtonText3: campaign.callToActionButtonText3 || undefined,
          callToActionButtonStyle3: campaign.callToActionButtonStyle3 || undefined,
          callToActionForm3: campaign.callToActionForm3 || undefined,
          callToActionTitle3: campaign.callToActionTitle3 || undefined,
          callToActionDescription3: campaign.callToActionDescription3 || undefined,
          callToActionUrlExternal3: campaign.callToActionUrlExternal3 || undefined
        }
      };
    }

    if (typeof campaign.callToActionFormExt !== 'undefined') {
      result.fields.callToActionFormExt = {
        // Note: Will clear the field if another form type is selected
        'nb-NO': (campaign.callToActionForm === 'external' && campaign.callToActionFormExt) ? createEntryLink(campaign.callToActionFormExt) : null
      };
    }

    if (typeof campaign.callToActionFormExt2 !== 'undefined') {
      result.fields.callToActionFormExt2 = {
        // Note: Will clear the field if another form type is selected
        'nb-NO': (campaign.callToActionForm2 === 'external' && campaign.callToActionFormExt2) ? createEntryLink(campaign.callToActionFormExt2) : null
      };
    }

    if (typeof campaign.callToActionFormExt3 !== 'undefined') {
      result.fields.callToActionFormExt3 = {
        // Note: Will clear the field if another form type is selected
        'nb-NO': (campaign.callToActionForm3 === 'external' && campaign.callToActionFormExt3) ? createEntryLink(campaign.callToActionFormExt3) : null
      };
    }

    // Dealer links:
    if (typeof campaign.dealers !== 'undefined') {
      result.fields.dealers = {
        'nb-NO': campaign.dealers ? campaign.dealers.map(createEntryLink) : null
      };
    }

    // Make links:
    if (typeof campaign.makes !== 'undefined') {
      result.fields.makes = {
        'nb-NO': campaign.makes ? campaign.makes.map(createEntryLink) : null
      };
    }

    // Model link:
    if (typeof campaign.model !== 'undefined') {
      result.fields.model = {
        'nb-NO': campaign.model ? createEntryLink(campaign.model) : null
      };
    }

    // Hide car preview on campaign page?
    if (typeof campaign.hideCarPreview !== 'undefined') {
      result.fields.hideCarPreview = {
        'nb-NO': campaign.hideCarPreview === true
      };
    }

    // Show campaign on modelpage?
    if (typeof campaign.showCampaignOnModelPage !== 'undefined') {
      result.fields.showCampaignOnModelPage = {
        'nb-NO': campaign.showCampaignOnModelPage === true
      };
    }

    if (typeof campaign.showCampaignInConfigurator !== 'undefined') {
      result.fields.showCampaignInConfigurator = {
        'nb-NO': campaign.showCampaignInConfigurator === true
      };
    }

    if (typeof campaign.loanExclusive !== 'undefined') {
      result.fields.loanExclusive = {
        'nb-NO': campaign.showCampaignInConfigurator && campaign.loanExclusive === true
      };
    }

    // Hide dates on campaign view?
    if (typeof campaign.hideDates !== 'undefined') {
      result.fields.hideDates = {
        'nb-NO': campaign.hideDates === true
      };
    }

    // Hidden campaign?
    if (typeof campaign.hiddenCampaign !== 'undefined') {
      result.fields.hiddenCampaign = {
        'nb-NO': campaign.hiddenCampaign === true
      };
    }

    // External campaign url?
    if (typeof campaign.externalCampaignPage !== 'undefined') {
      result.fields.externalCampaignPage = {
        'nb-NO': campaign.externalCampaignPage === true
      };
    }

    // MF override campaign
    if (typeof campaign.mfRotationOverride !== 'undefined') {
      result.fields.mfRotationOverride = {
        'nb-NO': campaign.mfRotationOverride === true
      };
    }

    if (typeof campaign.variables !== 'undefined') {
      result.fields.variables = {
        'nb-NO': campaign.variables
      };

      result.overwriteKeys.push('variables');
    }

    if (typeof campaign.variants !== 'undefined') {
      result.fields.variants = {
        'nb-NO': campaign.variants ? campaign.variants.map(createEntryLink) : null
      };
    }

    if (typeof campaign.lease !== 'undefined') {
      result.fields.lease = {
        'nb-NO': campaign.lease ? createEntryLink(campaign.lease) : null
      };
    }

    if (typeof campaign.includedEquipments !== 'undefined' || typeof campaign.includedFactoryEquipments !== 'undefined' || typeof campaign.availableColors !== 'undefined') {
      const includedEquipments = campaign.includedEquipments || [];
      const includedFactoryEquipments = campaign.includedFactoryEquipments || [];
      const availableColors = campaign.availableColors || [];

      result.fields.includedEquipment = {
        'nb-NO': includedEquipments.concat(includedFactoryEquipments, availableColors).map(createEntryLink)
      };
    }

    return result;
  }
};
